import { useEffect } from "react";
import { registerAgentControl } from "../../lib/webpageDebugBridge";
import type { AgentControl } from "./useAgentControl";

// Expose this live iframe to the chat-pane webpage-debugging tools. Register
// unconditionally — even when the step serves no page — so the tools can
// return an accurate error fast instead of waiting out a timeout.
export default function useAgentControlBridge(
  control: AgentControl,
  stepName: string,
  hasPage: boolean
) {
  const status = hasPage ? ("renderable" as const) : ("none" as const);

  useEffect(() => {
    return registerAgentControl({ stepName, status, control });
  }, [status, stepName, control]);
}
